export default __webpack_public_path__ + "static/icon_github-b1d6abd7a181316723ea5d9c4cd96c35.svg";